const initialState = {
  refiId: null,
  userId: null,
  vehicleId: null,
  addressId: null,
  owns: null,
  manualVerification: null,
  manualTradeline: false,
  finalize: false,
  /** flag set when backend indicates a VIN is required for this YMMT combo */
  vinRequiredError: false,
  productsNotAvailableError: false,
  /**
   * The server's own reason for the no-products 422, when it sent one. The VIN
   * field used to show a hardcoded "No products available for this vehicle" for
   * every 422 on that endpoint, which is wrong for the duplicate-VIN and
   * verify-mileage refusals that also land here.
   */
  productsNotAvailableMessage: null,
}

const currentApplication = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_REFI_APPLICATION_DATA':
      return {
        ...state,
        ...action.payload,
        vinRequiredError: false,
        productsNotAvailableError: false,
        productsNotAvailableMessage: null,
      }
    case 'RESET_REFI_APPLICATION_DATA':
      return initialState
    case 'VIN_REQUIRED_ERROR':
      return {
        ...state,
        vinRequiredError: true,
      }
    case 'CLEAR_VIN_REQUIRED_ERROR':
      return {
        ...state,
        vinRequiredError: false,
      }
    case 'PRODUCTS_NOT_AVAILABLE_ERROR':
      return {
        ...state,
        productsNotAvailableError: true,
        productsNotAvailableMessage: action.payload?.message || null,
      }
    default:
      return state
  }
}

export default currentApplication

export const selectCurrentRefiApplication = (state) => {
  return state.refis.currentApplication || {}
}
